import styled from 'styled-components';

export default styled.input`
  border: none;
  outline: none;
  background: transparent;
  font: inherit;
  color: inherit;
  width: 100%;
`;
